export enum BaseProductLineState {
  BASE_PRODUCT_LINE_ACTIVE = "BASE_PRODUCT_LINE_ACTIVE",
  BASE_PRODUCT_LINE_CANCELLED = "BASE_PRODUCT_LINE_CANCELLED",
  BASE_PRODUCT_LINE_MOVED = "BASE_PRODUCT_LINE_MOVED",
}
